import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { fmtMoneda } from '@/lib/cd2bPricing'
import { convencion, estiloBandera, fechaCorta } from '@/lib/pais'
import PageContainer from '@/components/common/PageContainer'
import { Card } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Alert, AlertDescription } from '@/components/ui/alert'

/**
 * El gerente de país abre las cotizaciones de su equipo SOLO PARA LEER (docs/179): la API ya
 * rechaza cualquier cambio, así que aquí no se pinta el asistente — solo lo vendido.
 */
export default function VistaSoloLectura({ propuesta, edicionLabel }) {
  const navigate = useNavigate()
  const asesor = [propuesta.consultorId?.firstName, propuesta.consultorId?.lastName].filter(Boolean).join(' ') || propuesta.consultorId?.email || 'su asesor'
  return (
    <PageContainer>
      <div className="flex items-center gap-3">
        <Button variant="ghost" size="icon" onClick={() => navigate('/equipo/pipeline')} aria-label="Volver al pipeline">
          <ArrowLeft size={18} />
        </Button>
        <h2 className="min-w-0 break-words font-display text-h3 sm:text-h2 font-semibold text-foreground">{propuesta.empresaNombre || 'Cotización'}</h2>
      </div>
      <Alert>
        <AlertDescription>Es la cotización de <strong>{asesor}</strong>. La ves porque es de tu equipo; solo su asesor puede cambiarla.</AlertDescription>
      </Alert>
      <fieldset disabled className="space-y-6 opacity-95">
        <Card className="p-4 sm:p-5 space-y-2 text-body-sm">
          <p><span className="text-subtle">Estado:</span> {propuesta.estadoEfectivo || propuesta.estado}</p>
          <p className="flex flex-wrap items-center gap-1.5">
            <span className="text-subtle">País:</span>
            {propuesta.pais && <span aria-hidden="true" className="inline-block h-3 w-4 rounded-sm border border-line" style={estiloBandera(propuesta.pais)} />}
            {propuesta.pais ? (convencion(propuesta.pais).nombre || propuesta.pais) : 'Sin país'}
          </p>
          <p><span className="text-subtle">Edición:</span> {edicionLabel(propuesta.edicion)}</p>
          <p><span className="text-subtle">Módulos:</span> {(propuesta.modulos || []).map((m) => m.name || m.code).join(', ') || '—'}</p>
          <p><span className="text-subtle">Mensual:</span> {fmtMoneda(propuesta.precioMensual || 0, propuesta.moneda || 'USD')}</p>
          {propuesta.vigenteHasta && <p><span className="text-subtle">Vigente hasta:</span> {fechaCorta(propuesta.vigenteHasta, propuesta.pais)}</p>}
        </Card>
      </fieldset>
    </PageContainer>
  )
}
